import { Controller, useFormContext } from 'react-hook-form'

import { F0DatePicker } from '@factorialco/f0-react'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'effectiveOn'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  onEffectiveOnChange: (value: string) => void
  isAutomaticExpensable?: boolean
}

function stringToDatePickerValue(dateString: string | undefined) {
  if (!dateString) return undefined

  const parsedDate = stringToDate(dateString, 'backend')

  if (!parsedDate.isValid()) return undefined

  const normalizedDate = parsedDate.toDate()

  return {
    granularity: 'day' as const,
    value: {
      from: normalizedDate,
      to: normalizedDate
    }
  }
}

const EffectiveOnField = ({
  isFieldMandatory,
  onEffectiveOnChange,
  isAutomaticExpensable = false,
  isFieldReadOnly
}: Props) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <F0DatePicker
          label={i18n.t('expenses_v2.forms.fields.trip_date.label')}
          required={isFieldMandatory}
          maxDate={new Date()}
          disabled={isReadOnly}
          placeholder={i18n.t('expenses_v2.forms.fields.effective_on.placeholder')}
          value={stringToDatePickerValue(field.value)}
          onChange={(value) => {
            if (value?.value?.from) {
              const dateStr = i18nDateToString(value.value.from, 'backend')
              field.onChange(dateStr)
              onEffectiveOnChange(dateStr)
            } else {
              field.onChange('')
              onEffectiveOnChange('')
            }
          }}
          error={castError(errors?.effectiveOn)}
          clearable
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(EffectiveOnField, FIELD_NAME))
